import { Component, OnDestroy, ViewChild, ChangeDetectorRef, AfterViewInit, OnInit } from '@angular/core';
import { IPackData, IPackItem, OrderStep } from '@app/certificates/packs/packs';
import { InfoService } from '@app/core/info/info.service';
import { Store } from '@ngrx/store';
import { selectorPacks, ActionPacksReviewSelection, ActionPacksReset, ActionPacksInitialize } from '@app/certificates/packs/packs.reducer';
import { Subject } from 'rxjs';
import { takeUntil, first } from 'rxjs/operators';
import { MatStepper } from '@angular/material/stepper';
import { selectorCertificate, ActionCertificatesInitialize } from '@app/certificates/manage/manage.reducer';
import { ManageService } from '@app/certificates/manage/manage.service';
import { ActionProfilePlanGet } from '@app/profile/profile-remaining-count/profile-plan.actions';
import { AuthenticationService } from '@app/core/auth/authentication.service';

@Component({
  selector: 'cloud-packs',
  templateUrl: './packs.component.html',
  styleUrls: ['./packs.component.scss'],
})
export class PacksComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('stepper') stepper: MatStepper;

  packData: any;
  selectedPack: IPackItem;
  orderToBeDesplayed: boolean;

  private unsubscribe$: Subject<void> = new Subject<void>();
  private buttonClickedForPackId: IPackItem['id'];
  protected wait = false;

  constructor(
    public info: InfoService,
    private store: Store<any>,
    private cd: ChangeDetectorRef,
    private manageService: ManageService,
    private auth: AuthenticationService,
  ) {
    this.store.dispatch(new ActionProfilePlanGet());
  }

  ngOnInit() {
    this.store
      .select(selectorPacks)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(packData => {
        this.packData = packData;
        this.orderToBeDesplayed = this.packData.order != null;
        this.selectedPack = this.packData.items?.filter((item) => item.id === packData.selectedPackId)[0];
        this.cd.detectChanges();
        if (this.stepper) {
          this.stepper.selectedIndex = this.packData.step;
        }

        this.store
          .select(selectorCertificate)
          .pipe(takeUntil(this.unsubscribe$))
          .pipe(first())
          .subscribe(certs => {
            if (!certs) {
              this.manageService.getAll().subscribe(response => {
                certs = response.data;
                this.store.dispatch(new ActionCertificatesInitialize({ certificates: certs }));
              });
            }
          });

      });
  }

  ngAfterViewInit() {
    if (!this.orderToBeDesplayed) {
      this.stepper.selectionChange.subscribe(selection => {
        // Забраняваме промяна на поръчката, щом сме стигнали до плащане
        if (selection.selectedIndex === OrderStep.PAYMENT) {
          selection.previouslySelectedStep.editable = false;
        }
      });
    }
  }

  get stepOneValid() {
    return this.buttonClickedForPackId;
  }

  get stepTwoValid() {
    return (this.packData)
      ? (this.packData.step > OrderStep.REVIEW)
      : false;
  }

  get isOrderStep() {
    if (this.stepper) {
      return this.stepper.selectedIndex === OrderStep.REVIEW;
    }

    return false;
  }

  get isPaymentStep() {
    if (this.stepper) {
      return this.stepper.selectedIndex === OrderStep.PAYMENT;
    }
    return false;
  }

  onBuyBtnClicked(ob) {
    this.buttonClickedForPackId = ob.packId;
    this.cd.detectChanges();
    this.store.dispatch(new ActionPacksReviewSelection({ packId: ob.packId }));
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.store.dispatch(new ActionPacksReset());
  }
}
